import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

import { toast } from "react-toastify";

import UserConfig from "../../components/UserConfig";
import UserModule from "../../components/UserModule";

import UserService from "../../services/UserService";

import "./users.scss";

interface userInterface {
  nome?: string,
  email?: string,
  id?: string | number,
  modules?: any,
};

const EditUser: React.FC<any> = (props) => {
  const { token } = props.state;
  const [user, setUser] = useState<userInterface>({
    nome: "",
    email: "",
    id: "",
  });

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const [id] = useState(props.match.params.id || "");

  const getUser = () => {
    setLoading(true);
    UserService.getUser(token, id)
      .then((response) => {
        setUser(response);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Erro ao buscar dados!");
        setError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  const send = (user: any) => {
    setLoading(true);
    setError(false);
    setSuccess(false);
    setRedirect(false);

    const { isAuthorised } = user;

    // UserService.handleUser(token, id, isAuthorised)
    //   .then((response: any) => {
    //     if (response) {
    //       toast.success("Dados salvos com sucesso!");
    //       getUser();
    //       setSuccess(true);
    //       setRedirect(true);
    //     }
    //     setLoading(false);
    //     setError(false);
    //     setRedirect(false);
    //   })
    //   .catch((error: any) => {
    //     toast.error("Erro ao salvar dados!");
    //     setSuccess(false);
    //     setLoading(false);
    //     setError(true);
    //     setRedirect(false);
    //   });
  };

  if (redirect) {
    return <Redirect to={{ pathname: "/usuarios" }} />;
  }

  return (
    <div className="dashboard-container">
      {loading && (
        <div className={"loading-mask"}>
          <FontAwesomeIcon icon={faCircleNotch} pulse />
        </div>
      )}

      <h1>Configuração de usuário</h1>
      <div className="module-container">
        <div className="module-item">
          <UserConfig
            initicialUser={user}
            error={error}
            send={send}
            loading={loading}
            success={success}
          />
        </div>
        <div className="module-item">
          <UserModule
            initicialModules={user.modules}
            initicialUser={user}
            error={error}
          />
        </div>
      </div>
    </div>
  );
}

export default EditUser;